import { authHeader } from "../util/auth-header";
import http from "../util/http-common";

export class ModelService {
  static async getAll() {
    return http.get("/cfadminsysmaintain/api/v1/models",{ headers: await authHeader()});
  }

  static async create(data: any) {
    return http.post("/cfadminsysmaintain/api/v1/models", data, { headers: await authHeader()} );
  }

  static async update(id: any, data: any) { //id to pass
    return http.put(`/cfadminsysmaintain/api/v1/models/${id}`, data, { headers: await authHeader()});
  }

  static async delete(id: number) {
    return http.delete(`/cfadminsysmaintain/api/v1/models/${id}`,{ headers: await authHeader()});
  }

}

export default ModelService;